'use client';

import { Suspense } from 'react';
import SignupContent from './SignupContent';

export default function SignupPage() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center opacity-70">Loading…</div>}>
      <SignupContent />
    </Suspense>
  );
} 